// extracted by mini-css-extract-plugin
export default {"code":"DataTable_code__+oPeL"};